"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trivignano-udinese": {
    "713b85b5": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "skipSearch": false
    }],
    "casali-fornaciata": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ef8f5e4": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "skipSearch": false
    }],
    "dogana-vecchia": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efc931a2": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "skipSearch": false
    }],
    "localita-casali-comugne-marcotti": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10c33a56": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "skipSearch": false
    }],
    "localita-san-marco": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b51fcefd": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "skipSearch": false
    }],
    "localita-san-michele": [{
      "hkey": "a08e1f15",
      "slug": "trivignano-udinese",
      "name": "Trivignano Udinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;